module.exports = __webpack_public_path__ + "img/blocks.be5030ca.webp";